import { BuilderContent } from '@builder.io/sdk';
import { FC } from 'react';

import { FooterMatrix } from '@/helpers/NavHelper';
import Footer from '@/modules/pages/footer';
import { Navigation } from '@/modules/pages/navigation/navigation';
import { ChunkedNav } from '@/types/Navigation';

interface DefaultLayoutProps {
  children?: React.ReactNode;
  footerItems: FooterMatrix[];
  headerItems: ChunkedNav;
  headerBuilderItems: BuilderContent[] | null;
}

const DefaultLayout: FC<DefaultLayoutProps> = (props) => {
  const { headerItems, headerBuilderItems, footerItems, children } = props;

  return (
    <div>
      <Navigation
        navigationItems={headerItems}
        builderNavLinks={headerBuilderItems}
        footerItems={footerItems}
      />
      {children}
      <Footer footerData={footerItems} />
    </div>
  );
};

export default DefaultLayout;
